export const vs2ngaLimitedReleaseDetailConstants = {
  VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
    "VS2NGA_LIMITED_RELEASE_DETAIL_LOADING",
  VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS",
  VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
    "VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const createVs2ngaLimitedReleaseDetailConstants = {
  CREATE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
    "CREATE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING",
  CREATE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "CREATE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS",
  CREATE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
    "CREATE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const editVs2ngaLimitedReleaseDetailConstants = {
  EDIT_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
    "EDIT_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING",
  EDIT_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "EDIT_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS",
  EDIT_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
    "EDIT_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const deleteVs2ngaLimitedReleaseDetailConstants = {
  DELETE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
    "DELETE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING",
  DELETE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "DELETE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS",
  DELETE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
    "DELETE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const addTargetVs2ngaLimitedReleaseDetailConstants = {
  ADD_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
    "ADD_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING",
  ADD_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "ADD_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS",
  ADD_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
    "ADD_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const removeTargetVs2ngaLimitedReleaseDetailConstants = {
  REMOVE_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
    "REMOVE_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING",
  REMOVE_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "REMOVE_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS",
  REMOVE_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
    "REMOVE_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const activateVs2ngaLimitedReleaseDetailConstants = {
  ACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
    "ACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING",
  ACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "ACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS",
  ACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
    "ACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const deactivateVs2ngaLimitedReleaseDetailConstants = {
  DEACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
    "DEACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING",
  DEACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "DEACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS",
  DEACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
    "DEACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE",
};
